import { DOCUMENT } from '@angular/common';
import { Directive, Inject, OnInit } from '@angular/core';
import { FinderThemeService } from '@finder/shared/services/theme-service/finder-theme.service';
import { loadCssResource } from '@finder/shared/utils/utils.dom';

@Directive({
    selector: '[finderTypography]',
})
export class TypographyDirective implements OnInit {
    constructor(
        private themeService: FinderThemeService,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    ngOnInit() {
        this.themeService.themeChange()
            .subscribe(theme => {
                this.setThemeFont(theme);
            });
    }

    // TODO - proper test coverage
    /* istanbul ignore next */
    private setThemeFont(theme) {
        switch (theme) {
            case 'ac-theme':
                loadCssResource(this.document, '/advanced-finder/fonts/nicotine.css');
                break;
            case 'gsc-theme':
                loadCssResource(this.document, '/advanced-finder/fonts/din.css');
                break;
        }
    }
}
